import { createContext, useEffect, useContext, useState } from "react";
import { useSession } from "@/providers/SessionProvider";
import { UserTypes } from '@/configs/AppConfig';

const DEFAULT_LAYOUTS = {
    SYSTEM_USER: {
        showSidebar: false,
        showToolbar: true,
        showFooter: true,
    },
    APP_USER: {
        showSidebar: false,
        showToolbar: true,
        showFooter: true,
    },
    GUEST: {
        showSidebar: false,
        showToolbar: false,
        showFooter: false,
    },
}

const LayoutContext = createContext(null);

const LayoutProvider = ({ children }) => {
    const { isAuthenticated, userType } = useSession()

    const [layout, setLayout] = useState({
        showSidebar: false,
        showToolbar: true,
        showFooter: false,
    });
    const updateLayout = (layout = DEFAULT_LAYOUTS.APP_USER) => {
        setLayout(layout);
    }
    const showDefaultLayout = () => {
        updateLayout(DEFAULT_LAYOUTS.APP_USER);
    }
    const hideLayout = () => {
        updateLayout({
            showSidebar: false,
            showToolbar: false,
            showFooter: false,
        });
    }


    useEffect(() => {
        if (userType == UserTypes.SYSTEM_USER) updateLayout(DEFAULT_LAYOUTS.SYSTEM_USER)
        else if (userType == UserTypes.APP_USER) updateLayout(DEFAULT_LAYOUTS.APP_USER)
        else updateLayout(DEFAULT_LAYOUTS.GUEST)
    }, [userType])

    return <LayoutContext.Provider value={{
        layout,
        updateLayout,
        showDefaultLayout,
        hideLayout
    }}>
        {children}
    </LayoutContext.Provider>;
};

export default LayoutProvider;

export const useLayout = () => useContext(LayoutContext);